export const linkData = [
  { id: 1, text: "Home", path: "/" },
  { id: 2, text: "About", path: "/about" },
  { id: 3, text: "Products", path: "/products" },
  { id: 4, text: "Contact", path: "/contact" },
  { id: 5, text: "Cart", path: "/cart" }
];
